/* DateRestriction.ts */

export enum DateRestrictionType {
  FIRST = "first",
  LAST = "last",
  DATE = "date",
}
